import { lt } from '@mews/framework';
import { FilterSidebarLayoutContent } from '../../../../components/layout';
import { SavedValuesProps, SidebarToggleProps } from '../common';
import {
    ReservationsContent,
    ReservationsFilterFields,
    ReservationsFilterValues,
    reservationsReportFilterSchema,
    reservationsUrlSchema,
    useFiltersQuery,
} from './components';
import { ExportDropdownButton } from './components/filters/components/ExportDropdownButton';

interface ReservationsFilterSidebarLayoutContentProps
    extends SidebarToggleProps,
        SavedValuesProps<ReservationsFilterValues> {
    defaultQueryParams?: object;
}

export const ReservationsFilterSidebarLayoutContent = ({
    saveValues,
    ...other
}: ReservationsFilterSidebarLayoutContentProps) => {
    const { hasLoyaltyPrograms, products, services, defaultValues: defaultFilterValues } = useFiltersQuery();

    return (
        <FilterSidebarLayoutContent<ReservationsFilterValues>
            {...other}
            filterSchema={reservationsReportFilterSchema}
            defaultFilterValues={defaultFilterValues}
            queryParamsSchema={reservationsUrlSchema}
            filterSidebar={{
                title: lt('Filter'),
                fields: (
                    <ReservationsFilterFields
                        hasLoyaltyPrograms={hasLoyaltyPrograms}
                        services={services}
                        products={products}
                    />
                ),
                actions: ({ filterValues }) => <ExportDropdownButton filterValues={filterValues} />,
            }}
        >
            {({ filterValues }) => {
                saveValues(filterValues);

                return <ReservationsContent filterValues={filterValues} />;
            }}
        </FilterSidebarLayoutContent>
    );
};
